export const getRefFromQuery = (queryString) => {
    let queryArray = queryString.search.split('&')
    queryArray[0] = queryArray[0].slice(1)
    console.log(queryArray)
    queryArray.forEach(a => {
        if (a.includes('ref')) {
            localStorage.setItem("cp_ref", a.split('=')[1])
        }
    })
}